<template>
        <div id="graph">
            <canvas id="realisedProfit" width="600" height="200"></canvas>
        </div>
       
</template>
<script>
    import axios from 'axios';
    export default {       

        props: {
            portfolioguid: String,
            securityprop: String,
            fromdate: String,
            daterangeid: Number,
            marketprop: Number
        },
        data: function () {
            return {
                portfolioGuid: this.portfolioguid,
                security: this.securityprop,
                fromDate: this.fromdate,
                dateRangeId: this.daterangeid,
                marketId: this.marketprop
               
            };
        },
        methods: {
            async getYearlyProfits() {                

                const { data } = await axios.get('/api/trades/GetPnLGraphData', {
                    params: {
                        portfolioGuid: this.portfolioGuid,                        
                        security: this.security,
                        fromDate: this.fromDate,
                        dateRangeId: this.dateRangeId,
                        marketId: this.marketId
                    }
                });                

                var planetChartData = {
                    type: 'bar',
                    data: {
                        labels: data.map(value => value.key),
                        datasets: [
                            { // one line graph
                                label: 'Realised Profit/Loss',
                                data: data.map(value => value.profitValue),
                                backgroundColor: data.map(value => value.profitValue < 0 ? 'rgba(255, 0, 0, 0.5)' : 'rgba(54,73,93,.5)'),
                                borderColor: data.map(value => value.profitValue < 0 ? '#9a0e35' : '#36495d'),
                                borderWidth: 1
                            },
                            { // one line graph
                                label: 'Brokerage',
                                data: data.map(value => value.brokerageValue),
                                backgroundColor: "yellow",
                                borderColor: data.map(value => value.brokerageValue < 0 ? '#9a0e35' : '#36495d'),
                                borderWidth: 0.5,
                                categoryPercentage: 0.5
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        lineTension: 1,
                        scales: {
                            x: {
                                stacked: true
                            },
                            y: {
                                ticks: {
                                    beginAtZero: true,
                                    padding: 25
                                }
                            }
                        }
                    }
                }

                this.createChart('realisedProfit', planetChartData);
            }
        },
        async mounted() {
            await this.getYearlyProfits();
        }
    }
</script>